import Toastr from "../../../../itrust_common/components/Toastr";

const DEFAULT_STATE = {
  saving: false,
  services: [],
  service: {},
  editing: {},
  rejectionLogs: [],
  rejectionLogsMeta: {},
  rejectionLogsLoading: false,
  ediFiles: [],
  ediFilesMeta: {},
  ediFilesLoading: false,
  ediFilesSyncing: false,
  ediFile: null,
  ediFileLoading: false,
  ediFileProcessing: false,
}

let changes = null

export const EdiClearingHouseReducer = (state = DEFAULT_STATE, action) => {
  const response = action.payload && (action.payload.data || action.payload.response)

  switch (action.type) {
    case 'EDI_CLEARING_HOUSE_SERVICES_LOAD_PENDING':
    case 'EDI_CLEARING_HOUSE_SERVICE_UPDATE_PENDING':
      return { ...state, saving: true };

    case 'EDI_CLEARING_HOUSE_SERVICES_LOAD_REJECTED':
    case 'EDI_CLEARING_HOUSE_SERVICE_UPDATE_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = { saving: false }
      return { ...state, ...changes };

    case 'EDI_CLEARING_HOUSE_SERVICE_UPDATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      let index = state.services.findIndex(item => item.id === response.add_on.id)
      state.services[index] = response.add_on
      changes = { saving: false }
      return { ...state, ...changes };

    case 'EDI_CLEARING_HOUSE_SERVICES_LOAD_FULFILLED':
      changes = { services: response.add_ons, rpa_addon_id: response.add_ons[0]?.id, saving: false }
      return { ...state, ...changes };

    case 'EDI_CLEARING_HOUSE_SERVICES_LOAD_FULFILLED':
      changes = { services: response.add_ons, rpa_addon_id: response.add_ons[0]?.id, saving: false }
      return { ...state, ...changes };

    case 'EDI_CLEARING_HOUSE_EDIT':
      changes = { editing: { ...state.editing, ...action.data } }
      return { ...state, ...changes };

    case 'EDI_CLEARING_HOUSE_EDIT_RESET':
      changes = { editing: {} }
      return { ...state, ...changes };

    case 'EDI_CLEARING_HOUSE_SERVICES_RESET':
      return { ...DEFAULT_STATE };

    case 'EDI_REJECTION_LOGS_LOAD_PENDING':
      return { ...state, rejectionLogsLoading: true };

    case 'EDI_REJECTION_LOGS_LOAD_REJECTED':
    case 'EDI_REJECTION_LOGS_UPDATE_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      return { ...state, rejectionLogsLoading: false };

    case 'EDI_REJECTION_LOGS_EXPORT_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      changes = {
        editing: false,
        saving: false,
      }
      return { ...state, ...changes };

    case 'EDI_REJECTION_LOGS_LOAD_FULFILLED':
      return {
        ...state,
        rejectionLogs: response.edi_clearing_house_rejection_logs || response.logs || [],
        rejectionLogsMeta: response.meta || {},
        rejectionLogsLoading: false,
      };
    case 'EDI_REJECTION_LOGS_UPDATE_FULFILLED': {
      Toastr.handleShow(true, response.meta.message, 201);

      const updatedRecord = response.edi_clearing_house_rejection_logs;

      if (!updatedRecord) {
        return state;
      }

      const rejectionLogs = [...state.rejectionLogs];

      let updatedData = rejectionLogs;

      for (const [index, log] of rejectionLogs.entries()) {
        if (log.id === updatedRecord.id) {
          updatedData = [
            ...rejectionLogs.slice(0, index),
            updatedRecord,
            ...rejectionLogs.slice(index + 1)
          ];
          break;
        }
      }

      return {
        ...state,
        rejectionLogs: updatedData,
        editing: {}
      };
    }

    case 'EDI_FILES_LOAD_PENDING':
      return { ...state, ediFilesLoading: true };

    case 'EDI_FILES_LOAD_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      return { ...state, ediFilesLoading: false };

    case 'EDI_FILES_LOAD_FULFILLED':
      return {
        ...state,
        ediFiles: response.edi_files || [],
        ediFilesMeta: response.meta || {},
        ediFilesLoading: false,
      };

    case 'EDI_FILES_SYNC_REMITS_PENDING':
      return { ...state, ediFilesSyncing: true };

    case 'EDI_FILES_SYNC_REMITS_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      return { ...state, ediFilesSyncing: false };

    case 'EDI_FILES_SYNC_REMITS_FULFILLED':
      Toastr.handleShow(true, response.message || 'Remit Files synced successfully', 200)
      return { ...state, ediFilesSyncing: false };

    case 'EDI_FILE_LOAD_PENDING':
      return { ...state, ediFileLoading: true, ediFile: null };

    case 'EDI_FILE_LOAD_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      return { ...state, ediFileLoading: false, ediFile: null };

    case 'EDI_FILE_LOAD_FULFILLED':
      return {
        ...state,
        ediFile: response.edi_file || null,
        ediFileLoading: false,
      };

    case 'EDI_FILE_PROCESS_REMIT_PENDING':
      return { ...state, ediFileProcessing: true };

    case 'EDI_FILE_PROCESS_REMIT_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      return { ...state, ediFileProcessing: false };

    case 'EDI_FILE_PROCESS_REMIT_FULFILLED':
      Toastr.handleShow(true, response.message || 'Remit processed successfully', 200)
      return { ...state, ediFileProcessing: false };

    default:
      return state
  }
}
